<div class="grid-x padding-left">
  @if (!editMode) {
    <div class="cell shrink padding-left">
      <span class="minor-margin-right">
        {{key}}
      </span>
    </div>
  }
  @if (editMode) {
    <div class="cell shrink padding-left">
      <input type="text" [(ngModel)]="key" style="background-color: white;" />
    </div>
    <div class="cell shrink">
      <button (click)="updateKey()" aria-label="Save Edit">
        <span class="show-for-sr">Save Edit</span>
        <svg-icon icon="icon-save" class="tiny dark-gray"></svg-icon>
      </button>
    </div>
  }

  @if (subkeys.length !== 0 && !editMode) {
    <div class="cell shrink text-right">
      <button (click)="addNewNode()" aria-label="Add New Node">
        <span class="show-for-sr">Add New Node</span>
        <svg-icon icon="icon-plus" class="tiny dark-gray"></svg-icon>
      </button>
      <button title="Edit" attr.aria-label="Rename Key {{key}}" (click)="edit()">
        <span class="show-for-sr">Rename Key {{key}}</span>
        <svg-icon icon="icon-pencil" class="tiny dark-gray" aria-hidden="true"></svg-icon>
      </button>
      <button title="Delete" attr.aria-label="Delete Key {{key}}" (click)="delete(key, true)">
        <span class="show-for-sr">Delete Key {{key}}</span>
        <svg-icon icon="icon-trash" class="tiny dark-gray" aria-hidden="true"></svg-icon>
      </button>
    </div>
  }
  @if (subkeys.length !== 0) {
    <div class="cell auto padding-left padding-right">
      <div class="cell large-12">{{ '{' }}</div>
      @for (data of subkeys; track data; let i = $index) {
        <workflow-context-leaf [key]="subkeys[i]" [context]="values" [index]="i" (contextCopied)="bubbleCopy($event)" (refreshView)="bubbleRefresh($event)"></workflow-context-leaf>
      }
      <div class="cell large-12">{{ '}' }}</div>
    </div>
  }
  @if (subkeys.length === 0 && !editMode) {
    <div class="cell auto text-right padding-right">
      @if (key === 'value') {
        <button title="Copy To Clipboard" attr.aria-label="Copy Key {{key}} To The Clipboard" (click)="copyContextValue(key)">
          <span class="show-for-sr">Copy Key To The Clipboard {{key}}</span>
          <svg-icon icon="icon-clipboard" class="tiny dark-gray" aria-hidden="true"></svg-icon>
        </button>
      }
      @if (key !== 'value') {
        <button (click)="addNewNode()" aria-label="Add New Node">
          <span class="show-for-sr">Add New Node</span>
          <svg-icon icon="icon-plus" class="tiny dark-gray"></svg-icon>
        </button>
        <button title="Edit" attr.aria-label="Edit Key {{key}}" (click)="edit()">
          <span class="show-for-sr">Edit Key {{key}}</span>
          <svg-icon icon="icon-pencil" class="tiny dark-gray" aria-hidden="true"></svg-icon>
        </button>
        <button title="Delete" attr.aria-label="Delete Key {{key}}" (click)="delete(key, true)">
          <span class="show-for-sr">Delete Key {{key}}</span>
          <svg-icon icon="icon-trash" class="tiny dark-gray" aria-hidden="true"></svg-icon>
        </button>
      }
    </div>
  }
</div>
<confirm-dialog [showDialog]="dialogService.showDialog" [dialogType]="dialogService.dialogType" [message]="dialogService.message" (onDialogConfirm)="onDialogConfirm()" (onDialogClose)="onDialogClose()"></confirm-dialog>
